import { LuggageAmountValues } from "./LuggageAmountValues.model";

export class LuggageAmounteServiceClass {
    serviceClassId: number;
    luggageAmountId: number;
    internalDescription: string;
    luggageValues: LuggageAmountValues[];
}
